import { Navigate } from "react-router-dom";

export default function AdminRoute({ children }) {
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  if (!isAdmin) {
    return <Navigate to="/signin" replace />; // שימי פה את הנתיב האמיתי של ההתחברות שלך
  }

  return children;
}
